import React from 'react';
import { FaGlobe } from 'react-icons/fa';
import LangSwitcher from './LangSwitcher';
import * as styles from './LangSwitchersList.module.scss';
var LangSwitcherList = function LangSwitcherList() { return /*#__PURE__*/ React.createElement("div", { className: styles.langSwitcherList }, /*#__PURE__*/ React.createElement(FaGlobe, null), " ", /*#__PURE__*/ React.createElement(LangSwitcher, { lang: "ja" }, "\u65E5\u672C\u8A9E"), " |", ' ', /*#__PURE__*/ React.createElement(LangSwitcher, { lang: "en" }, "English")); };
export default LangSwitcherList;
